import { render, staticRenderFns } from "./ReportSendParcelsOnBranchFee.vue?vue&type=template&id=5ffffef8&"
import script from "./ReportSendParcelsOnBranchFee.vue?vue&type=script&lang=js&"
export * from "./ReportSendParcelsOnBranchFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports